import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductStocksExportComponent } from './product-stocks-export.component';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    ProductStocksExportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule,
  ],
  exports: [
    ProductStocksExportComponent
  ]
})
export class ProductStocksExportModule { }
